/* GA4 view_item_list for the product lists Shopify has no standard event for (HG-69):
   the search results page, the predictive search dropdown, and the product previews
   in the megamenu and mobile drawer.

   Each list carries its data in a <script data-heimat-item-list> rendered by
   snippets/heimat-item-list-data.liquid. This file publishes it as the Shopify
   custom event `heimat_view_item_list`; the "Heimatgut view_item_list" custom pixel
   in Customer Events sends it on to GA4. Consent is enforced there, by the pixel's
   Analytics permission, so nothing here needs to check it.

   Collection pages are deliberately left out: Shopify publishes collection_viewed on
   its own and Simprosys already turns that into view_item_list.

   Shopify.analytics.publish is a queueing stub from content_for_header until the web
   pixels manager has loaded, so calling it early is safe. */
(function () {
  'use strict';

  var SELECTOR = 'script[data-heimat-item-list]';
  // A list only counts once it has been on screen this long: a menu swept past on
  // hover intent, or a dropdown result for "pop" replaced by "popcorn" while typing,
  // is not a list the visitor looked at.
  var DWELL_MS = 500;

  // data-trigger decides when a list counts and how often:
  //   load    - on render, once per element. The search page's filters swap in a
  //             fresh element, which is a new list view.
  //   visible - after DWELL_MS on screen, once per item_list_id per page view, so
  //             reopening the same menu tab is not counted again.
  //   settled - after DWELL_MS on screen, once per element. Every query in the search
  //             dropdown renders a new element, so each settled query counts once.
  var publishedElements = typeof WeakMap === 'function' ? new WeakMap() : null;
  var shownSince = typeof WeakMap === 'function' ? new WeakMap() : null;
  var publishedListIds = {};

  function publish(data) {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    if (!data.items || !data.items.length) return;
    data.currency = (window.Shopify.currency && window.Shopify.currency.active) || null;
    window.Shopify.analytics.publish('heimat_view_item_list', data);
  }

  function read(el) {
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function isShown(el) {
    var container = el.parentElement;
    if (!container) return false;
    if (typeof container.checkVisibility === 'function') {
      // The megamenu card, the drawer and the search dropdown hide with
      // opacity/visibility for their transitions, not display, so check both.
      return container.checkVisibility({ opacityProperty: true, visibilityProperty: true });
    }
    return container.getClientRects().length > 0;
  }

  function publishElement(el) {
    if (publishedElements.has(el)) return;
    publishedElements.set(el, true);
    var data = read(el);
    if (!data) return;
    if (el.getAttribute('data-trigger') === 'visible') {
      if (publishedListIds[data.item_list_id]) return;
      publishedListIds[data.item_list_id] = true;
    }
    publish(data);
  }

  // Returns ms until the next scan is needed for a list still dwelling, or 0.
  function scan(skipDwell) {
    if (!publishedElements) return 0;
    if (window.Shopify && window.Shopify.designMode) return 0;
    var now = Date.now();
    var nextIn = 0;
    var lists = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < lists.length; i++) {
      var el = lists[i];
      if (publishedElements.has(el)) continue;
      if ((el.getAttribute('data-trigger') || 'load') === 'load') {
        publishElement(el);
        continue;
      }
      if (!isShown(el)) {
        shownSince.delete(el);
        continue;
      }
      if (!shownSince.has(el)) shownSince.set(el, now);
      var remaining = shownSince.get(el) + DWELL_MS - now;
      if (skipDwell || remaining <= 0) publishElement(el);
      else if (!nextIn || remaining < nextIn) nextIn = remaining;
    }
    return nextIn;
  }

  var scanTimer = null;
  function scheduleScan(delay) {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(function () {
      scanTimer = null;
      var nextIn = scan(false);
      if (nextIn) scheduleScan(nextIn + 20);
    }, delay);
  }

  function boot() {
    var nextIn = scan(false);
    if (nextIn) scheduleScan(nextIn + 20);
    // Menus open through data-open/hidden/data-active (heimat-mega-menu.js), and
    // search results arrive as new children (facets.js on the search page,
    // heimat-search.js in the dropdown). Throttled rather than debounced, so a page
    // that never stops mutating (an autoplaying slider) cannot postpone the scan
    // forever. The dwell itself is measured per list.
    new MutationObserver(function () { if (!scanTimer) scheduleScan(50); }).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-open', 'hidden', 'data-active', 'data-level', 'data-state']
    });
    // A visitor who clicks a dropdown result before the dwell is up has plainly seen
    // the list. The click navigates away, so count it now.
    document.addEventListener('heimat:search:result-click', function () { scan(true); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
